import { render, staticRenderFns } from "./AskueTable.vue?vue&type=template&id=5dea80be&"
import script from "./AskueTable.vue?vue&type=script&lang=ts&"
export * from "./AskueTable.vue?vue&type=script&lang=ts&"
import style0 from "./AskueTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports